'use client';

import { faLock, faPlus } from '@fortawesome/free-solid-svg-icons';
import cx from 'classnames';
import { forwardRef, LegacyRef } from 'react';

import { CustomIcon } from '@/components/CustomIcon';

import styles from './Pill.module.scss';
import { IPill } from './Pill.types';

export const Pill: React.FC<IPill> = forwardRef(
  (
    { name, value, onChange, checked = false, disabled = false },
    ref: LegacyRef<HTMLLabelElement> | null,
  ) => {
    return (
      <label
        className={cx(styles.pill, {
          [styles.disabled]: disabled,
          [styles.checked]: checked,
        })}
        htmlFor={name}
        ref={ref}
      >
        <input
          tabIndex={-1}
          type="checkbox"
          id={name}
          name={name}
          value={value}
          onChange={(event) => onChange?.(event.target.checked)}
          checked={checked}
          disabled={disabled}
        />
        <CustomIcon icon={disabled ? faLock : faPlus} />
        {name}
      </label>
    );
  },
);

Pill.displayName = 'Pill';
